import './index.scss';

class SiteFooter {
    constructor(root) {
        this.root = root;
    }
}

window.app.run(() => {
    document.querySelectorAll('.site-footer').forEach((node) => {
        new SiteFooter(node);
    });
});
